export default "__VITE_ASSET__bdb34017__"